import { NotebookPen } from "lucide-react";
import { notesStorage } from "@/lib/notes-storage";

const notesProvider = {
  id: "notas",
  label: "Notas",
  icon: NotebookPen,
  iconBg: "bg-indigo-50",
  iconColor: "text-indigo-600",
  // linked_label lets "Pérez" find notes about the Pérez family even without text match
  fields: ["title", "content", "tags", "linked_label"],
  // Load from local storage — search never triggers a remote fetch
  load: (districtId) =>
    notesStorage.getAll(districtId).then((notes) =>
      notes.filter((n) => !n._deleted && !n.archived)
    ),
  buildItem: (n) => ({
    id: n.id,
    title: n.title || "Sin título",
    subtitle: n.content
      ? n.content.slice(0, 60).replace(/\s+/g, " ").trim()
      : "Nota sin contenido",
    route: `/notes/${n.id}`,
    recent: null,
  }),
};

export default notesProvider;
